import { SubtitlesGroup } from '../../../store/slices/subtitles/types';

export enum PlayerConfigVersion {
  JSP = 'jsp',
  PREFERENCES = 'preferences',
}

export interface PlayerConfigType {
  compliance: Compliance;
  jurisdiction: string;
  jwtToken: string;
  userId: string;
  screenName: string;
  operatorId: string;
  userType: string;
  videoStream: boolean;
  videoStreamRaw: Record<'video_stream', string> | undefined;
  videoVolume: number;
  gameEffectsVolume: number;
  selectedChipIndex: number | undefined;
  selectedChipParamsRaw: Record<'selected_chip', string> | undefined;
  countryCode: string;
  currencyMultiplier: number;
  lobbyFilters: Record<string, Record<string, string[]>>;
  tournamentsIRLEData?: string;
  cashbacksIRLEData?: string;
  prizedropsIRLEData?: string;
  isBanned: boolean;
  showOtherMessages: boolean;
  subtitlesEnabled: Record<SubtitlesGroup, boolean>;
  subtitlesOnboarded: boolean;
  subtitlesPositionsRaw: string | undefined;
  subtitlesSize: string | undefined;
  netWinBalanceMap: Record<string, number>;
  isSecondBetboardEnabled: boolean;
  hfAnimationEnabled: boolean;
}

export interface Compliance {
  showSessionId?: boolean; // Display session id in the game
  sessionBalance?: boolean; // Show session balance popup at load end
  waitResultBeforeLeave?: boolean; // Show "Stay till round end" popup
  sessionBalanceWasSet?: boolean; // Session balance was set (not a feature flag, used for login if session balance feature was enabled)
  creditHelpInfo?: boolean; // Show credit information in game help
  maxPlayerLimitInfo?: boolean; // Show information about max player limit at the table at once
  netPosition?: boolean; // Show session net position
  hideCurrency?: boolean; // Do not display currency
  displayBonusBalance?: boolean; // Display bonus balance
  showSessionTimer?: boolean; // Show session timer
  serverClockSync?: boolean; // TODO: in-game clock must be synced with server time
  cashOnly?: boolean; // TODO: show only cash values (no coins)
  clientVersion?: boolean; // TODO: show client version
  engineVersion?: boolean; // TODO: show engine version
  extendedAutoplay?: boolean; // Extended autoplay version
  hideAutoplay?: boolean; // Need to hide autoplay button
  /** Whether user is allowed to leave the game with active bet */
  isRestrictedToLeaveWithActiveBet?: boolean;
}

export interface IPlayerConfigResponseXML {
  Jurisdiction: string;
  currency_multiplier: string;
  elapsedTime: string;
  jwtToken: string;
  nwb: string;
  operator_id: string;
  pausePlayUrl: string;
  playLimitUrl: string;
  player_ip_country: string;
  player_operator_country: string;
  'playerconfig-param': Array<Record<string, string>>;
  screenName: string;
  selfTestUrl: string;
  session: string;
  stats_collector_uuid: string;
  user_id: string;
  user_type: string;
}

export interface IPlayerConfigResponseJSON {
  currencyMultiplier: number; // why is this a string?
  description: string;
  elapsedTime: string;
  errorCode: string;
  jurisdiction: string;
  jwtToken: null | string;
  netWinBalanceMap: Record<string, number>;
  operatorId: string;
  params: {
    video_so: string;
    onebj_autostand: number;
    bg_music: number;
    video_stream: string;
    tms_data: string;
    pds_data: string;
    cbs_data: string;
    usergcount: number;
    autostandcounter: number;
    video_sounds: number;
    onebj_autostandcounter: number;
    showdt_rbsidebets: boolean;
    islighttheme: boolean;
    betbehind_doubledown: boolean;
    game_effects: number;
    showextrastats: boolean;
    tableid: string; // why is it here?
    isBanned: boolean;
    anim_enable: boolean;
    betbehind_insurance: boolean;
    showroads: boolean;
    showfulltables: boolean;
    grid_view: string;
    show_quick_guide_bingo: boolean;
    vo_music: number;
    gr_roadsetting: string;
    betbehind_split: boolean;
    dealer_voice: number;
    betbehind_updated: 'null'; // why is it string null?
    showdt_bssidebets: boolean;
    selected_chip: string;
    blackjacktabletype: string;
    rtp_view: boolean;
    showothermessages: boolean;
    sub_enabled_gr1?: boolean;
    sub_enabled_gr2?: boolean;
    sub_enabled_gr3?: boolean;
    sub_onboarded?: boolean;
    sub_positions?: string;
    sub_size?: string;
    lobby_filters?: string;
    issecondbetboardenabled: boolean;
    hf_animation_enabled: boolean;
  };
  pausePlayUrl: string;
  playLimitUrl: string; // why is this a string?
  playerIPCountry: string;
  screenName: string;
  selfTestUrl: string;
  statsCollectorUUID: null;
  userId: string;
  userType: string;
}
